<template>
    <div :style="{ backgroundColor: homeImage.color || 'white', height:'100vh', ...charteVars }" class="homeContainer">
        <div class="homeImage">
            <img :src="homeResource" alt="">
            <div class="overlay"></div>
        </div>
        <div class="homeContent">
            <h1 class="homeText" :style="textStyle" v-html="processText(homeImage.text)"></h1>
            <div class="home-arrow" :style="launchStyle" @click="exitHomePage">
                <img v-if="launchImage" :src="launchImage" alt="" class="launchImage">
                <span v-html="processText(homeImage.launch_text)"></span>
                <q-icon name="arrow_forward_ios"></q-icon>

            </div>
        </div>
    </div>
</template>
<script>
import { ref, onMounted, computed } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
import { useExhibitStyle } from "../../composables/useExhibitStyle";
import { useHomeLayout } from "../../composables/useHomeLayout";
export default {
    props: ["homeImage", "exhibitIdProps"],
    setup(props, ctx) {
        let homeResource = ref();
        const route = useRoute();
        const { cssVars, load: loadCharte } = useExhibitStyle(route.params.id ?? props.exhibitIdProps);
        const charteVars = computed(() => cssVars());
        const { textStyle, launchStyle } = useHomeLayout(() => props.homeImage);
        let exhibitId = ref();
        let launchResource = ref();
        let launchImage = ref();
        const start = async () => {
            exhibitId.value = route.params.id ?? props.exhibitIdProps;
            loadCharte();
            await getHomeFile();
            await getLaunchResource();
            if(launchResource.value?.launch_image_id) await getLaunchFile();
        };

        const processText = (text) => {
            if (!text) return text;
            return text.replace(/\\n/g, '\n');
        };

        const exitHomePage = () => {
            ctx.emit("exit");
        }

        const getHomeFile = async () => {
            try {
                setTimeout(async() => {
                    let name = props.homeImage.name;
                let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
                let response = await axios.get(url);
                var base64data = response.data;
                homeResource.value = base64data;                }, 500);
               
            } catch (error) {
                console.log(error);
            }
        };

        const getLaunchFile = async () => {
            try {
                let name = launchResource.value.name;
                let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
                let response = await axios.get(url);
                var base64data = response.data;
                launchImage.value = base64data;
            } catch (error) {
                console.log(error);
            }
        };
        const getLaunchResource = async ( )=>{
            try {
                let url = `${process.env.VUE_APP_BASEURL}/launchImage/${exhibitId.value}`;
                let response = await axios.get(url);
                launchResource.value = response.data[0];

            } catch (error) {
                console.log(error);
            }
        }



        

        onMounted(start);

        return {
            homeResource,
            exhibitId,
            launchImage,
            launchResource,
            exitHomePage,
            processText,
            charteVars,
            textStyle,
            launchStyle

        }
    }

}
</script>
<style scoped>
.homeContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
}

.homeImage {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.homeImage img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.overlay {
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.homeContent {
    z-index: 1;
    text-align: center;
    padding: 2rem;
}

.homeText {
    font-size: var(--expo-title-size, 3rem);
    margin-bottom: 1rem;
    color: var(--expo-title-color, #FFF);
    font-weight: var(--expo-title-weight, bold);
    font-family: var(--expo-title-font, inherit);
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    white-space: pre-line;
}

.home-arrow {
    font-size: 1.5rem;
    color: #FFF;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    background-color: #333;
    padding: 10px 20px;
    border-radius: 25px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s;
}

.home-arrow span {
    white-space: pre-line;
}

.home-arrow:hover {
    transform: scale(1.05);
}

.home-arrow q-icon {
    margin-left: 10px;
}

.launchImage{
    max-height: 100px;
    width: auto;
    object-fit: contain;
    background: transparent;
    margin-right: 8px;
}
</style>